<script>
import { h } from 'vue';
import language from '@core/mixins/language';
import { normalizeHrefsInHtmlFragment } from '@utils/normalize-href.js';

export default {
    name: 'ADangerousHtml',

    mixins: [language],

    inheritAttrs: false,

    props: {
        content: {
            type: String,
            default: '',
        },

        tag: {
            type: String,
            default: 'div',
        },

        refinements: {
            type: Object,
            default: () => ({}),
        },
    },

    computed: {
        normalizedRefinements() {
            return { injectHrefLocale: true, ...this.refinements };
        },

        refinedContent() {
            let result = this.content || '';

            if (this.normalizedRefinements.injectHrefLocale) {
                result = normalizeHrefsInHtmlFragment(result, this.pageLocaleMarker);
            }
            return result;
        },
    },

    render() {
        const vnodeAttrs = {
            ...this.$attrs,
            class: [this.$attrs.class, 'a-dangerous-html'],
            innerHTML: this.refinedContent,
        };

        return h(this.tag, vnodeAttrs);
    },
};
</script>

<style lang="postcss">
.a-dangerous-html {
    p:not(:last-of-type) {
        margin-bottom: 16px;
    }

    ::marker {
        content: initial;
    }

    ul {
        & > li {
            margin-bottom: 16px;
            padding-inline-start: 24px;

            &:last-child {
                margin: 0;
            }
            &::before {
                content: '';
                position: relative;
                top: -.1em;
                inset-inline-start: -18px;
                margin-inline-end: -4px;
                width: 4px;
                height: 4px;
                display: inline-block;
                vertical-align: middle;
                background-color: currentcolor;
                border-radius: 50%;
            }
        }
    }

    ul > li > p, ol > li > p {
        display: contents;
    }

    a {
        cursor: pointer;
        color: var(--av-brand-primary);
        text-decoration: none;
        &:hover {
            color: var(--av-brand-secondary);
        }
        &:focus {
            background: var(--av-brand-secondary-light);
            color: var(--av-brand-primary);
        }
        &:active {
            background: none;
            color: var(--av-brand-primary);
        }
    }

    a:hover {
        color: var(--av-brand-secondary);
    }

    sup {
        font-size: 10px;
        vertical-align: super;
    }

    small {
        font-size: 10px;
    }

    small sup {
        font-size: 8px;
    }

    mark.cdx-marker {
        background-color: var(--av-brand-light);
        padding: 0 0.25em;
    }
}
</style>
